module.exports = ".camara{display:block;width:80%;margin:0 auto}.table th,.table td{padding:0.75rem 0}.btn-x{padding:0.375rem 0.5rem}\n"